import HBIcon from "../../HBIcon";
import styles from "./index.module.less";
/**
 *
 * @param {{
 *  className: string,
 *  message: string,
 *  style: import("react").CSSProperties
 * }} props
 * @returns
 */
export default function Tip({ className = "", message, style }) {
  return (
    <div className={styles.infotip + " " + className} style={style}>
      <HBIcon type="ic_info" className={styles.icon} />
      <span>{message}</span>
    </div>
  );
}
